/** The tab's session storage, or null where the browser refuses it. */
export const browserSessionStorage = (): Storage | null => {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage;
  } catch {
    return null;
  }
};
